module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-timetal"
  }, [_c('div', {
    staticClass: "d-timetal__container"
  }, [_vm._m(0), _vm._v(" "), (_vm.isLoadingStilData) ? _c('div', {
    staticStyle: {
      "width": "500px"
    }
  }, [_c('Loader')], 1) : [_c('GrundskoleIndberetningTimetal', {
    staticClass: "marg-1-top",
    attrs: {
      "stilData": _vm.stilData,
      "isReadOnly": true
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "submit-bttn__container"
  }, [_c('button', {
    staticClass: "bttn bttn--primary",
    class: {
      'bttn--loading': _vm.isSendingToStil
    },
    staticStyle: {
      "width": "165px"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("Afslut og indberet\n        ")])])]], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-timetal__container__header"
  }, [_c('h2', {
    staticClass: "uppercase"
  }, [_vm._v("Resume")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ec2fc8f0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Reporting/GrundskoleIndberetningResume.vue
// module id = 2154
// module chunks = 1